import { defineMessages } from 'react-intl';

export const scope = 'app.components.ApproveGroupings';

export const messages = defineMessages({
  fetchFailed: {
    id: `${scope}.fetchFailed`,
    defaultMessage: 'Unable to approve groupings at this time. Please try again later',
  },
  finalizeFailed: {
    id: `${scope}.finalizeFailed`,
    defaultMessage: 'The groups could not be finalized. Please try again.',
  },
});
